import { io } from "socket.io-client";

export const initSocket = () => {
  const options = {
    forceNew: true,
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    timeout: 20000,
      withCredentials: true,   // ← yahi credentials

    // 🔑 IMPORTANT FIX
    transports: ["polling", "websocket"],
  };

  return io(process.env.REACT_APP_MAIN_BACKEND, options);
};
